import Image from "next/image";
import { useState, useEffect } from "react";
import { fetchGetCompanySiteSettings } from "../../../services/api";

export default function Header({ company }) {

    const [activePages, setActivePages] = useState([])
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    useEffect(() => {
        const pages = []
        fetchGetCompanySiteSettings()
        .then(res => {
            pages.push({route: '', name: "Home"})
            res.showNew === true ? pages.push({route: "novos", name: "0 Km"}) : null;
            res.showUsed === true ? pages.push({route: "seminovos", name: "Seminovos"}) : null;
            res.showArmored === true ? pages.push({route: "blindados", name: "Blindados"}) : null;
            pages.push({route: 'sobre-nos', name: "Sobre"})
            res.showFinancing === true ? pages.push({route: "financiamento", name: "Financiamento"}) : null;
            res.showVehiclePurchase === true ? pages.push({route: "venda-seu-veiculo", name: "Venda seu Veículo"}) : null;
            res.showInsurance === true ? pages.push({route: "seguro", name: "Seguro"}) : null;
            pages.push({route: 'contato', name: "Contato"})
            setActivePages(pages)
        })
    }, [])

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }


    return (
        <>
            <header className="header-style-one header-sticky">
                            <div className="col-lg-12">
                                <div className="flex">
                                    <a href="/">
                                        {company.logo?
                                        <Image
                                            src={company.logo}
                                            alt="logo"
                                            width={240}
                                            height={64}
                                            sizes="100vw"
                                            quality={100}
                                            loading="lazy"
                                            style={{
                                                marginTop: '10px',
                                                marginBottom: '4px'
                                            }} />

                                        : <div></div>    }
                                    </a>
                                    <div className={`spinner-master ${isMenuOpen ? "active" : ""}`}>
                                    <button
                                    onClick={toggleMenu}
                                    className="mobile-menu-toggle header-toggle-btn ms-4 d-lg-none" aria-label="Abrir Menu">
                                        <div className="spinner-spin">
                                            <span className="spinner diagonal part-1"></span>
                                            <span className="spinner horizontal"></span>
                                            <span className="spinner diagonal part-2"></span>
                                        </div>
                                    </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className=" d-flex align-items-center justify-content-around">
                                    <nav className="at_nav_menu d-none d-lg-block">
                                        <ul>
                                            {activePages.map((page, index) => (
                                                <li key={index}><a href={`/${page.route}`}>{page.name}</a></li>
                                            ))}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
            </header>
            <div className={`mobile-menu position-fixed bg-black deep-shadow ${isMenuOpen ? 'active' : null}`}>
                <nav className="mobile-menu-wrapper">
                    <ul>
                        {activePages.map((page, index) => (
                            <li key={index}><a href={`/${page.route}`}>{page.name}</a></li>
                        ))}
                    </ul>
                </nav>
            </div>
        </>
    );
}